import React, { Fragment } from "react";
import { Typography, Grid } from "@material-ui/core";
import { addToast } from "components/notifications";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { gql } from "@apollo/client";

const USER_DATA = gql`
  query userData($id: ID) {
    userData(id: $id) {
      id
      userName
    }
  }
`;

function Dashboard() {
  const { data } = useQueryWithErrorHandling(USER_DATA, {
    variables: { id: 1 },
    onCompleted: (data) => {
      addToast(`This is my userData: ${data?.userData?.userName}`, "success");
    },
  });
  return (
    <Fragment>
      <Typography>This is my dashboard...</Typography>
      <Grid>And this is my GQL response: {data?.userData?.userName}</Grid>
    </Fragment>
  );
}

export default Dashboard;
